<template>
    <main class="main" id="main">
        <div class="top_line">
            <div class="container">
                <h1>Почему тысячи людей заказывают на ХОЧУ-ПОЕСТЬ?</h1>
            </div>
        </div>
        <!----------About us cards------------->

        <section class="section s-about_us">
            <div class="container">
                <div class="about_cards">

                    <div class="card_inner">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/1.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/1.svg" alt="">
                        </div>
                        <p>Все рестораны</p>
                    </div>

                    <div class="card_inner">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/2.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/2.svg" alt="">
                        </div>
                        <p>Никаких псевдобаллов</p>
                    </div>

                    <div class="card_inner">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/3.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/3.svg" alt="">
                        </div>
                        <p>Любовь с первого клика</p>
                    </div>

                    <div class="card_inner resize">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/4.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/4.svg" alt="">
                        </div>
                        <p>Всем по 200!</p>
                    </div>

                    <div class="card_inner">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/5.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/5.svg" alt="">
                        </div>
                        <p>Реальный cash-back</p>
                    </div>

                    <div class="card_inner">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/6.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/6.svg" alt="">
                        </div>
                        <p>Народный контроль</p>
                    </div>

                    <div class="card_inner">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/7.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/7.svg" alt="">
                        </div>
                        <p>Своя Hops тусовка</p>
                    </div>
                    <div class="card_inner">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/8.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/8.svg" alt="">
                        </div>
                        <p>Ревизорро ХОЧУ-ПОЕСТЬ</p>
                    </div>

                    <div class="card_inner">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/9.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/9.svg" alt="">
                        </div>
                        <p>Огромный выбор блюд</p>
                    </div>

                    <div class="card_inner">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/10.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/10.svg" alt="">
                        </div>
                        <p>Зарабатывайте с нами!</p>
                    </div>

                    <div class="card_inner">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/11.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/11.svg" alt="">
                        </div>
                        <p>Таймер</p>
                    </div>

                    <div class="card_inner">
                        <div class="card_images">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/12.png" alt=""><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/12.svg" alt="">
                        </div>
                        <p>Мы не ленивые!</p>
                    </div>

                </div>
            </div>
        </section>
        <!---------Mega Startup------------->

        <section class="section s-startup">
            <div class="container">
                <div class="startup">
                    <h1>СУМАСШЕДШИЙ START-UP ПРОРВАЛСЯ
                        В ТВОЮ СТРАНУ И ПОСЕЛИЛСЯ
                        В ТВОЁМ ГОРОДЕ!</h1>
                    <div class="startup_description">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/startup_logo.png" alt="">
                        <div class="startup_text">

                            <p>Ровно один год назад идея инновационного сервиса
                                по доставке еды зародилась у небольшой группы IT-шников.
                                Как всем известно, программисты много времени проводят дома
                                или в офисе и часто пользуются доставкой еды, но ни один
                                сервис их не устроил на все 100%. </p>

                            <p> «Тогда, летом 2016, мы просто изобрели доставку еды заново.
                                До нас ее тоже делали и тоже доставляли, но мы привнесли
                                технологии. Создать сервис может каждый, но живут этим,
                                хотят и могут далеко не все. Отсюда и посредственный
                                результат». - делится сооснователь проекта Хочу-Поесть Сергей Сердюков</p>

                            <p>С 1 октября 2017 сервис ХОЧУ-ПОЕСТЬ запустился в России и странах
                                СНГ. За год привлечено 3,1 млн. долларов инвестиций на российский
                                рынок и 16 млн. долларов на европейские рынки. Открыты call-centre,
                                отдел маркетинга и рекламы и IT-отдел в Москве и Ростове-на- Дону.
                                Отделы подключения ресторанов также активно работают в России,
                                Украине, Беларуси, Казахстане, Молдове. С 1 ноября 2017 года Хочу-Поесть
                                начал завоевывать европейские страны.</p>

                        </div>
                    </div>
                    <div class="startup_images_row">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/startup1.png" alt="">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/startup2.png" alt="">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/startup3.png" alt="">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/startup4.png" alt="">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/startup5.png" alt="">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/startup6.png" alt="">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/startup7.png" alt="">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/startup8.png" alt="">
                    </div>
                </div>
            </div>
        </section>

        <!---------More about us------------->
        <section class="section s-about_more">
            <div class="container">
                <div class="about_review">

                    <div class="about_us_box">

                        <div class="box_title">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/frame_about1.png" alt="">
                            <p>Мы сделали всё наоборот, и получилось вкуснее</p>

                        </div>

                        <div class="box_bottom">

                            <div class="bottom_text">
                                <p>Было принято решение – <strong>сначала спросить</strong>  у целевой аудитории, как им нравится заказывать еду, потом спросить у рестораторов, как им нравится принимать заказы на доставку. Так, во многих городах о нас узнали еще до открытия сервиса.<strong> Нам прислали множество ответов.</strong></p>
                                <p>Оказывается, что задержка доставки часто происходит из-за того, что агрегаторы не интегрируются с системой заказов ресторана. А клиенты не любят заказывать через сервисы доставки, потому что слишком много времени уходит на выбор блюд и невозможно найти любимый ресторан.</p>
                                <p><strong>Больше всего, всех раздражают</strong> псевдо-бонусы, которые якобы экономят деньги на доставке, но на самом деле 1000 бонусов могут оказаться всего лишь бургером в 70 р.</p>
                            </div>

                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/about_hamb.png" alt="">

                        </div>

                    </div>

                    <div class="about_us_box">

                        <div class="box_title">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/about_us/frame_about1.png" alt="">
                            <p>Что получилось?</p>

                        </div>

                        <div class="box_bottom">

                            <div class="bottom_text">
                                <p>Инновационный сервис доставки еды Хочу-Поесть с заказом еды в 2 клика, интеграцией в систему заказов ресторанов, выплатами в реальном времени и понятной программой лояльности <strong>1 рубль = 1 рубль и ТОЧКА!</strong> Уникальные акции на еду, которые вы не встретите нигде, кроме нашего сервиса и множество иных сюрпризов, которые завоюют Вашу на протяжении всей дружбы с Хочу-Поесть.</p>
                                <p>Не менее интересным оказался тот факт, что, несмотря на прогресс конкурентов, многие россияне не совсем понимают, как работают агрегаторы доставки еды. А некоторые и вовсе не слышали об этом, отсюда и негативные отзывы, о том, что доставка долгая или блюда привозят холодными.</p>
                                <p>Агрегатор доставки еды Хочу-Поесть – это посредник между рестораном и клиентом, который позволяет выбрать и заказать еду удобно, быстро и в одном месте. Но и здесь мы стали в чем-то первыми. С первого дня работы сервиса,<strong> будет работать mr.Hops</strong>, который ежедневно заказывает еду и проверяет качество продуктов и доставки. Так или иначе, рестораны с низким качеством сервиса будут ассоциироваться с нами, мы не можем себе этого позволить, поэтому такие рестораны будут сняты с нашего сервиса</p>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </section>
    </main>
</template>

<script>
export default {
  name: 'about'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/about.vue